<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button
          class="page-panel-header-control-button"
          size="mini"
          type="primary"
          @click="back"
        >返回</el-button>
      </div>
      <div class="page-panel-header__title">企业动态</div>
    </div>
    <el-form ref="form" label-width="90px" class="page-panel__body">
      <table class="form-editor">
        <tr>
          <th>
            <span class="required_column">*</span>文章标题
          </th>
          <td>
            <el-input v-model="newsParam.newsTitle" placeholder="请输入新闻标题"></el-input>
          </td>
        </tr>
        <tr>
          <th>副标题</th>
          <td>
            <el-input v-model="newsParam.newsSubhead" placeholder="请输入新闻副标题"></el-input>
          </td>
        </tr>
        <tr>
          <th>
            <span class="required_column">*</span>作者
          </th>
          <td>
            <el-input v-model="newsParam.newsWriter" placeholder="请输入作者"></el-input>
          </td>
        </tr>
        <tr>
          <th>
            <span class="required_column">*</span>文章简介
          </th>
          <td>
            <el-input v-model="newsParam.newsSmBody" placeholder="请输入新闻简介" type="textarea"></el-input>
          </td>
        </tr>
        <tr>
          <th>发布时间</th>
          <td>
            <el-date-picker
              v-model="newsParam.promTime"
              type="date"
              placeholder="选择发布时间"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </td>
        </tr>
        <tr>
          <th>缩略图</th>
          <td>
            <el-upload
              action="/file/upload"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :headers="headers"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <th>
            <span class="required_column">*</span>文章编辑
          </th>
          <td>
            <!-- <ueditor
              :config="editorConfig"
              v-model="newsParam.newsBody"
              :thumbnailSize="{width:200}"
            ></ueditor> -->
            <editor v-model="newsParam.newsBody" :min-height="200" />
          </td>
        </tr>
      </table>
    </el-form>
    <div class="article_footer_control">
      <!-- 1：保存草稿 0：正常发布 -->
      <el-button type="primary" @click="addnews(1)">存草稿</el-button>
      <el-button type="primary" @click="addnews(0)">发布</el-button>
    </div>
  </div>
</template>
<script>
import * as newsApi from '@/api/adminApi/zh/news';
import { localStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      dynamicTags: [],
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      headers: {
        token: localStorage.get('token')
      },
      newsParam: {
        // 默认当前时间
        promTime: this.$options.filters.toDate(new Date(), 'yyyy-MM-dd')
      }
    };
  },
  methods: {
    checkInfo(info) {
      if (!info.newsTitle) {
        this.$notify({
          title: '警告',
          message: '请输入文章标题',
          type: 'warning'
        });
        return false;
      } else if (info.newsTitle.length > 70) {
        this.$notify({
          title: '警告',
          message: '文章标题字数不能超过70',
          type: 'warning'
        });
        return false;
      } else if (!info.newsWriter) {
        this.$notify({
          title: '警告',
          message: '请输入文章作者',
          type: 'warning'
        });
        return false;
      } else if (info.newsWriter.length > 20) {
        this.$notify({
          title: '警告',
          message: '作者姓名超过20',
          type: 'warning'
        });
        return false;
      } else if (!info.newsSmBody) {
        this.$notify({
          title: '警告',
          message: '请输入文章简介',
          type: 'warning'
        });
        return false;
      } else if (info.newsSmBody.length > 250) {
        this.$notify({
          title: '警告',
          message: '文章简介不能超过250字',
          type: 'warning'
        });
        return false;
      } else if (!info.newsBody) {
        this.$notify({
          title: '警告',
          message: '请输入文章内容',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    back() {
      this.$router.push({
        name: 'article',
        params: {
          activeTab: '企业动态'
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.dialogImageUrl = res.url;
      this.newsParam.picMain = res.url;
    },
    addnews(type) {
      if (this.checkInfo(this.newsParam)) {
        newsApi.addnews({ ...this.newsParam, newsStatus: type }).then(res => {
          this.$router.push({
            name: 'article',
            params: {
              activeTab: '企业动态'
            }
          });
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/enterprise/add.vue